'use strict';
/**
 * @author Maxim Seredkin
 */
export default ['SecurityRestService', '$q', '$location', '$window',
                function(SecurityRestService, $q, $location, $window) {
                    let _me;
                    let count_new_transactions = 0
                    let isOpenNewRequestsList = false

                    const PROJECT_MANAGER = 'ROLE_PROJECT_MANAGER'; // Менеджер проекта
                    const PROJECT_CURATOR = 'ROLE_PROJECT_CURATOR'; // Куратор проекта

                    const SUPERVISOR = 'ROLE_SUPERVISOR'; // Руководитель
                    const ADMINISTRATOR = 'ROLE_ADMINISTRATOR'; // Администратор

                    const GOVERNMENT = 'ROLE_GOVERNMENT'; // Правительство
                    const MINOWNING = 'ROLE_MINOWNING' //
                    const MINEK = 'ROLE_MINEK';
                    const OIV = 'ROLE_OIV'; // Куратор ОИВ
                    const MUNICIPALITY = 'ROLE_MUNICIPALITY'; // Муниципалити
                    const OMSU = 'ROLE_OMSU';

                    const INVESTOR = 'ROLE_INVESTOR'; // Инвестор ? не существует
                    const REGISTRY_CURATOR = 'ROLE_REGISTRY_CURATOR'; // Куратор реестра ? не существует

                    let deferred = $q.defer();

                    SecurityRestService.me(null, (data) => {
                        _me = angular.copy(data._embedded);
                        //_me.authorities[0].authority = 'ROLE_MINOWNING';
                        deferred.resolve();
                    }, data => {
                        // loginHref();
                    });

                    SecurityRestService.transactions(null, (data) => {
                        count_new_transactions = angular.copy(data._embedded)
                    })

                    const readRules = {
                        // Страницы для всех
                        // "/welcome": [PROJECT_MANAGER, PROJECT_CURATOR, SUPERVISOR, ADMINISTRATOR, GOVERNMENT, MINOWNING, MINEK, OIV, MUNICIPALITY, OMSU],
                        // "/reference": [PROJECT_MANAGER, PROJECT_CURATOR, SUPERVISOR, ADMINISTRATOR, GOVERNMENT, MINOWNING, MINEK, OIV, MUNICIPALITY, OMSU],
                        // "/error": [PROJECT_MANAGER, PROJECT_CURATOR, SUPERVISOR, ADMINISTRATOR, GOVERNMENT, MINOWNING, MINEK, OIV, MUNICIPALITY, OMSU],
                        // "/users/account": [PROJECT_MANAGER, PROJECT_CURATOR, SUPERVISOR, ADMINISTRATOR, GOVERNMENT, MINOWNING, MINEK, OIV, MUNICIPALITY, OMSU],
                        // Меню
                        "/orgs": [PROJECT_MANAGER, ADMINISTRATOR, GOVERNMENT, MINOWNING, MINEK, OIV, MUNICIPALITY, OMSU],
                        "/staffs": [PROJECT_MANAGER, ADMINISTRATOR, GOVERNMENT, MINOWNING, MINEK, OIV, MUNICIPALITY, OMSU],
                        "/lands": [PROJECT_MANAGER, ADMINISTRATOR, GOVERNMENT, MINOWNING, MINEK, OIV, MUNICIPALITY, OMSU],
                        "/invest-activity": [PROJECT_MANAGER, ADMINISTRATOR, GOVERNMENT, MINOWNING, MINEK, OIV, MUNICIPALITY, OMSU],
                        "/reports/project-chronology":  [PROJECT_MANAGER, ADMINISTRATOR, GOVERNMENT, MINOWNING, MINEK, OIV, MUNICIPALITY, OMSU],
                        "/users": [ADMINISTRATOR, MINEK],
                        // Справочники
                        "/src-categories": [ADMINISTRATOR, MINEK],
                        "/support-tools": [ADMINISTRATOR, MINEK],
                        "/units": [ADMINISTRATOR, MINEK],
                        "/okveds": [ADMINISTRATOR, MINEK],
                        "/maintenance-kinds": [ADMINISTRATOR, MINEK],
                        "/industries": [ADMINISTRATOR, MINEK],
                        "/areas": [ADMINISTRATOR, MINEK],
                        "/countries": [ADMINISTRATOR, MINEK],
                        "/municipalities": [ADMINISTRATOR, MINEK],
                        "/project-statuses": [ADMINISTRATOR, MINEK],
                        "/investor-countries": [ADMINISTRATOR, MINEK],
                        "/land-categories": [ADMINISTRATOR, MINEK],
                        "/phases": [ADMINISTRATOR, MINEK],
                        "/milestones": [ADMINISTRATOR, MINEK],
                        "/taxes": [ADMINISTRATOR, MINEK],
                        "/ownership-forms": [ADMINISTRATOR, MINEK],
                        "/hazard-classes": [ADMINISTRATOR, MINEK],
                        "/support-types": [ADMINISTRATOR, MINEK],
                        "/operation-types": [ADMINISTRATOR, MINEK],
                        // Меню
                        "/support-measures": [PROJECT_MANAGER, ADMINISTRATOR, GOVERNMENT, MINOWNING, MINEK, OIV, MUNICIPALITY, OMSU],
                        "/audits": [ADMINISTRATOR, MINEK],
                        '/sign':  [ADMINISTRATOR, MUNICIPALITY],
                        '/primary-appeals': [ADMINISTRATOR, MUNICIPALITY],
                        // Проекты
                        "/projects": [PROJECT_MANAGER, PROJECT_CURATOR, SUPERVISOR, ADMINISTRATOR, GOVERNMENT, MINOWNING, MINEK, OIV, MUNICIPALITY, OMSU],
                        "/dashboard": [PROJECT_MANAGER, PROJECT_CURATOR, SUPERVISOR, ADMINISTRATOR, GOVERNMENT, MINOWNING, MINEK, OIV, MUNICIPALITY, OMSU],
                        "/projects/:projectId": [PROJECT_MANAGER, PROJECT_CURATOR, SUPERVISOR, ADMINISTRATOR, GOVERNMENT, MINOWNING, MINEK, OIV, MUNICIPALITY, OMSU],
                        "/projects/requests/reviewed": [PROJECT_MANAGER, ADMINISTRATOR, MINEK, GOVERNMENT, MINOWNING, MUNICIPALITY, OMSU, OIV],
                        "/projects/requests/rejected": [PROJECT_MANAGER, ADMINISTRATOR, MINEK, GOVERNMENT, MINOWNING, MUNICIPALITY, OMSU, OIV],
                        "/projects/requests/finalization": [PROJECT_MANAGER, ADMINISTRATOR, MINEK, GOVERNMENT, MINOWNING, MUNICIPALITY, OMSU, OIV],
                        "/projects/trash": [PROJECT_MANAGER, ADMINISTRATOR, MINEK, GOVERNMENT, MINOWNING, MUNICIPALITY, OMSU, OIV],
                    }

                    const writeRules = {
                        // Страницы для всех
                        // "/welcome": [PROJECT_MANAGER, PROJECT_CURATOR, SUPERVISOR, ADMINISTRATOR, GOVERNMENT, MINOWNING, MINEK, OIV, MUNICIPALITY, OMSU],
                        // "/reference": [PROJECT_MANAGER, PROJECT_CURATOR, SUPERVISOR, ADMINISTRATOR, GOVERNMENT, MINOWNING, MINEK, OIV, MUNICIPALITY, OMSU],
                        // "/error": [PROJECT_MANAGER, PROJECT_CURATOR, SUPERVISOR, ADMINISTRATOR, GOVERNMENT, MINOWNING, MINEK, OIV, MUNICIPALITY, OMSU],
                        // "/users/account": [PROJECT_MANAGER, PROJECT_CURATOR, SUPERVISOR, ADMINISTRATOR, GOVERNMENT, MINOWNING, MINEK, OIV, MUNICIPALITY, OMSU],
                        // Меню
                        "/orgs": [PROJECT_MANAGER, ADMINISTRATOR, GOVERNMENT, MINEK, OIV, MUNICIPALITY, OMSU],
                        "/staffs": [PROJECT_MANAGER, ADMINISTRATOR, GOVERNMENT, MINEK, OIV, MUNICIPALITY, OMSU],
                        "/lands": [PROJECT_MANAGER, ADMINISTRATOR, GOVERNMENT, MINEK],
                        "/invest-activity": [PROJECT_MANAGER, ADMINISTRATOR, GOVERNMENT, MINEK, OMSU],
                        "/reports/project-chronology":  [PROJECT_MANAGER, ADMINISTRATOR, GOVERNMENT, MINEK, OIV, MUNICIPALITY, OMSU],
                        "/users": [ADMINISTRATOR, MINEK],
                        // Справочники
                        "/src-categories": [ADMINISTRATOR, MINEK],
                        "/support-tools": [ADMINISTRATOR, MINEK],
                        "/units": [ADMINISTRATOR, MINEK],
                        "/okveds": [ADMINISTRATOR, MINEK],
                        "/maintenance-kinds": [ADMINISTRATOR, MINEK],
                        "/industries": [ADMINISTRATOR, MINEK],
                        "/areas": [ADMINISTRATOR, MINEK],
                        "/countries": [ADMINISTRATOR, MINEK],
                        "/municipalities": [ADMINISTRATOR, MINEK],
                        "/project-statuses": [ADMINISTRATOR, MINEK],
                        "/investor-countries": [ADMINISTRATOR, MINEK],
                        "/land-categories": [ADMINISTRATOR, MINEK],
                        "/phases": [ADMINISTRATOR, MINEK],
                        "/milestones": [ADMINISTRATOR, MINEK],
                        "/taxes": [ADMINISTRATOR, MINEK],
                        "/ownership-forms": [ADMINISTRATOR, MINEK],
                        "/hazard-classes": [ADMINISTRATOR, MINEK],
                        "/support-types": [ADMINISTRATOR, MINEK],
                        "/operation-types": [ADMINISTRATOR, MINEK],
                        // Меню
                        "/support-measures": [ADMINISTRATOR, GOVERNMENT, MINEK, MUNICIPALITY],
                        "/audits": [ADMINISTRATOR, MINEK],
                        '/sign':  [ADMINISTRATOR, MUNICIPALITY],
                        // Проекты
                        "/projects": {
                            "create": [PROJECT_MANAGER, ADMINISTRATOR, GOVERNMENT, MINEK, OIV, MUNICIPALITY, OMSU],
                            'all': [MINEK, ADMINISTRATOR, GOVERNMENT, OIV, MUNICIPALITY, OMSU],
                            'owner': [PROJECT_MANAGER],
                            'delete': [ADMINISTRATOR],
                        },
                        "/dashboard": [PROJECT_MANAGER, PROJECT_CURATOR, SUPERVISOR, ADMINISTRATOR, GOVERNMENT, MINEK, OIV, MUNICIPALITY, OMSU],
                        "/projects/:projectId": {
                            'all': [ADMINISTRATOR, PROJECT_MANAGER, GOVERNMENT, MINEK, OIV, MUNICIPALITY, OMSU],
                            'partial': [PROJECT_CURATOR],
                            'team': [MINEK, ADMINISTRATOR],
                        },
                        "/projects/requests/reviewed": {
                            "approve": [ADMINISTRATOR, MINEK],
                            "remove": [PROJECT_MANAGER, MUNICIPALITY, GOVERNMENT, OMSU, OIV]
                        },
                        "/projects/requests/finalization": {
                            "approve": [ADMINISTRATOR, MINEK],
                            "reject": [ADMINISTRATOR, MINEK],
                            "remove": [PROJECT_MANAGER, MUNICIPALITY, GOVERNMENT, OMSU, OIV]
                        },
                        "/projects/requests/rejected": {
                            "remove": [ADMINISTRATOR, MINEK],
                        },
                        "/projects/trash": {
                            'all': [MINEK, ADMINISTRATOR, GOVERNMENT, OIV, MUNICIPALITY, OMSU],
                            'owner': [PROJECT_MANAGER],
                        },
                    }

                    return {
                        wait: wait,
                        isAuth: isAuth,
                        getAuthorities: getAuthorities,
                        getUsername: getUsername,
                        getFullName: getFullName,
                        getUser: getUser,
                        getNameSurname: getNameSurname,
                        hasAllAuthorities: hasAllAuthorities,
                        hasAnyAuthorities: hasAnyAuthorities,
                        hasAuthority: hasAuthority,
                        isOwner: isOwner,
                        waitnewRequests: waitnewRequests,
                        openNewRequestsList: openNewRequestsList,
                        getOpenNewRequest: getOpenNewRequest,
                        isAdministrator: isAdministrator,
                        isProjectManager: isProjectManager,
                        isProjectCurator: isProjectCurator,
                        isRegistryCurator: isRegistryCurator,
                        isInvestor: isInvestor,
                        isSupervisor: isSupervisor,
                        logout: logout,
                        loginHref: loginHref,
                        isAllowRead: isAllowRead,
                        isAllowWrite: isAllowWrite,
                        PROJECT_MANAGER: PROJECT_MANAGER, // Менеджер проекта
                        PROJECT_CURATOR: PROJECT_CURATOR, // Куратор проекта
                        REGISTRY_CURATOR: REGISTRY_CURATOR, // Куратор реестра
                        INVESTOR: INVESTOR, // Инвестор
                        SUPERVISOR: SUPERVISOR, // Руководитель
                        ADMINISTRATOR: ADMINISTRATOR, // Администратор
                        GOVERNMENT: GOVERNMENT, // Правительство
                        MINOWNING: MINOWNING, //
                        MINEK: MINEK,
                        OIV: OIV, // Куратор ОИВ
                        MUNICIPALITY: MUNICIPALITY, // Муниципалити
                        OMSU: OMSU
                    };

                    function isAllowWrite(path, action) {
                        let allowRoles = writeRules[path];
                        if (action && !!allowRoles) allowRoles = allowRoles[action];
                        if (!Array.isArray(allowRoles)) return false;
                        return isAuth() && hasAnyAuthorities(allowRoles);
                    }

                    function isAllowRead(path) {
                        const allowRoles = readRules[path];
                        if (!Array.isArray(allowRoles)) return false;
                        return isAuth() && hasAnyAuthorities(allowRoles);
                    }

                    function waitnewRequests() {
                        if (!Number.isInteger(count_new_transactions))
                            count_new_transactions = 0
                        return count_new_transactions
                    }
                    
                    function openNewRequestsList() {
                        isOpenNewRequestsList = !isOpenNewRequestsList
                    }

                    function getOpenNewRequest() {
                        return isOpenNewRequestsList
                    }

                    // region Function

                    function wait() {
                        return deferred.promise;
                    }

                    function isAuth() {
                        return _me != null;
                    }

                    function getAuthorities() {
                        return _me.authorities;
                    }

                    function isAdministrator() {
                        if (_me == null) return false;

                        return _me.authorities.some((reallyAuthority) => angular.equals(reallyAuthority.authority, ADMINISTRATOR));
                    }

                    function isProjectManager() {
                        if (_me == null) return false;

                        return _me.authorities.some((reallyAuthority) => angular.equals(reallyAuthority.authority, PROJECT_MANAGER));
                    }

                    function isProjectCurator() {
                        if (_me == null) return false;

                        return _me.authorities.some((reallyAuthority) => angular.equals(reallyAuthority.authority, PROJECT_CURATOR));
                    }

                    function isRegistryCurator() {
                        if (_me == null) return false;

                        return _me.authorities.some((reallyAuthority) => angular.equals(reallyAuthority.authority, REGISTRY_CURATOR));
                    }

                    function isSupervisor() {
                        if (_me == null) return false;

                        return _me.authorities.some((reallyAuthority) => angular.equals(reallyAuthority.authority, SUPERVISOR));
                    }

                    function isInvestor() {
                        if (_me == null) return false;

                        return _me.authorities.some((reallyAuthority) => angular.equals(reallyAuthority.authority, INVESTOR));
                    }

                    function hasAllAuthorities(authorities) {
                        if (!(_me != null && Array.isArray(_me.authorities))) return false;

                        if (!Array.isArray(authorities)) return false;

                        for (let authority of authorities) {
                            if (!_me.authorities.some((reallyAuthority) => angular.equals(reallyAuthority.authority, authority))) {
                                return false;
                            }
                        }

                        return true;
                    }

                    function hasAnyAuthorities(authorities) {
                        if (!(_me != null && Array.isArray(_me.authorities))) return false;

                        if (!Array.isArray(authorities)) return false;

                        for (let authority of authorities) {
                            if (_me.authorities.some((reallyAuthority) => angular.equals(reallyAuthority.authority, authority))) {
                                return true;
                            }
                        }

                        return false;
                    }

                    function hasAuthority(authority) {
                        if (!(_me != null && Array.isArray(_me.authorities))) return false;

                        return _me.authorities.some((reallyAuthority) => angular.equals(reallyAuthority.authority, authority));
                    }

                    function getUsername() {
                        return _me.username;
                    }

                    function getFullName() {
                        return _me.staff.fullName;
                    }

                    function getUser() {
                        return _me;
                    }

                    function getNameSurname() {
                        return `${_me.staff.firstName} ${_me.staff.surname}`;
                    }

                    function isOwner(project) {
                        if (!(_me != null && _me.staff != null && project != null && project.manager != null)) return false;

                        return project.manager.id === _me.staff.id;
                    }

                    function loginHref () {
                        $window.location.replace($window.location.origin + '/login');
                    }

                    function logout() {
                        // SecurityRestService.logout(null, (data) => {
                        //     let redirectUrl = $window.location.origin;

                        //     SecurityRestService.logout(null, (data) => {
                        //         //_me = angular.copy(data._embedded);
                        //         // deferred.resolve();
                        //         console.log(data);
                        //     });
                        //     // const baseElements = document.getElementsByTagName('base');

                        //     // if (baseElements != null && baseElements[0] != null) {
                        //     //     const basePath = baseElements[0].href;

                        //     //     if (basePath != null) {
                        //     //         redirectUrl = basePath;
                        //     //     }
                        //     // }

                        //     redirectUrl += 'login';

                        //     console.log(redirectUrl);

                        //     $window.location.replace(redirectUrl);
                        // });

                        loginHref();
                    }

                    // endregion
                }];
